"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[336],{

/***/ 4232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/atoms/Container/Container.tsx

var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto w-full px-4 md:max-w-5xl",
        children: children
    });
};


;// CONCATENATED MODULE: ./components/atoms/Container/index.ts



/***/ }),

/***/ 1210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ NavigationItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/atoms/NavigationItem/NavigationItem.tsx




var NavigationItem = function(param) {
    var href = param.href, title = param.title;
    var asPath = (0,router.useRouter)().asPath;
    var isActive = asPath.startsWith(href);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: classnames_default()(isActive ? "font-bold text-off-black dark:text-off-white" : "font-medium text-grey-700 md:text-grey-500 hover:text-off-black dark:hover:text-off-white", "md:underlined transition relative block whitespace-nowrap text-2xl md:text-lg"),
                children: title
            })
        })
    });
};


;// CONCATENATED MODULE: ./components/atoms/NavigationItem/index.ts



/***/ }),

/***/ 2092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.modern.js
var index_modern = __webpack_require__(425);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/atoms/Icon/Icon.tsx

var Icon = function(param) {
    var icon = param.icon;
    var Icon1 = "";
    switch(icon){
        case "CLOSE":
            Icon1 = "fas fa-times fa-2x";
            break;
        case "DOWNLOAD":
            Icon1 = "fas fa-download fa-2x";
            break;
        case "GITHUB":
            Icon1 = "fab fa-github fa-2x";
            break;
        case "INSTAGRAM":
            Icon1 = "fab fa-instagram fa-2x";
            break;
        case "LINKEDIN":
            Icon1 = "fab fa-linkedin-in fa-2x";
            break;
        case "MENU":
            Icon1 = "fas fa-bars fa-2x";
            break;
        case "YOUTUBE":
            Icon1 = "fab fa-youtube fa-2x";
            break;
        case "MAIL":
            Icon1 = "fas fa-envelope fa-2x";
            break;
        case "FACEBOOK":
            Icon1 = "fab fa-facebook fa-2x";
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: Icon1
        })
    });
};


;// CONCATENATED MODULE: ./components/atoms/Icon/index.ts


;// CONCATENATED MODULE: ./components/molecules/SocialIcons/SocialIcons.tsx


var SocialIcons = function(param1) {
    var profiles = param1.profiles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "flex gap-6",
        children: profiles.map(function(param) {
            var url = param.url, name = param.name, icon = param.icon;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "w-6 h-6 opacity-70 hover:opacity-100 transition",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    title: name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        icon: icon
                    })
                })
            }, name);
        })
    });
};


;// CONCATENATED MODULE: ./components/molecules/SocialIcons/index.ts


;// CONCATENATED MODULE: ./components/organisms/Footer/Footer.tsx


var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "flex flex-col md:flex-row gap-4 items-center justify-center md:justify-between mt-8 md:mt-20 px-4 md:px-20 py-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "\xa9 ",
                    new Date().getFullYear(),
                    " Krutik Parikh"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcons, {
                profiles: [
                    {
                        name: "Github",
                        url: "https://github.com/parikrut",
                        icon: "GITHUB"
                    },
                    {
                        name: "LinkedIn",
                        url: "https://www.linkedin.com/in/parikrut/",
                        icon: "LINKEDIN"
                    },
                    {
                        name: "Facebook",
                        url: "https://www.facebook.com/people/Krutik-Parikh/100076183866649/",
                        icon: "FACEBOOK"
                    },
                    {
                        name: "Instagram",
                        url: "https://www.instagram.com/ikrutikparikh/",
                        icon: "INSTAGRAM"
                    },
                    {
                        name: "Youtube",
                        url: "https://www.youtube.com/channel/UCe0Aoc-4Eo_ywNYsPo5NEKg?view_as=subscriber",
                        icon: "YOUTUBE"
                    },
                    {
                        name: "Email",
                        url: "mailto:4krutikparikh@gmail.com",
                        icon: "MAIL"
                    }, 
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/organisms/Footer/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/atoms/BurgerIcon/BurgerIcon.tsx


var BurgerIcon = function(param) {
    var isOpen = param.isOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("burger-icon", {
            open: isOpen
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
};


;// CONCATENATED MODULE: ./components/atoms/BurgerIcon/index.ts


// EXTERNAL MODULE: ./components/atoms/NavigationItem/index.ts + 1 modules
var NavigationItem = __webpack_require__(1210);
;// CONCATENATED MODULE: ./components/atoms/ThemeToggle/ThemeToggle.tsx



var ThemeToggle = function() {
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,index_modern/* useTheme */.F)(), resolvedTheme = ref1.resolvedTheme, setTheme = ref1.setTheme;
    // After mounting, we have access to the theme
    (0,react.useEffect)(function() {
        return setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "Toggle Dark Mode",
        type: "button",
        className: "p-2 bg-transparent border-2 border-grey-300 dark:border-grey-700 rounded-full dark:bg-transparent flex items-center justify-center hover:ring-2 hover:ring-offset-2 ring-grey-300 dark:hover:ring-2 dark:hover:ring-offset-2 dark:ring-grey-200 transition-all",
        onClick: function() {
            return setTheme(resolvedTheme === "dark" ? "light" : "dark");
        },
        children: mounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    className: "w-5 h-5 text-grey-800 dark:text-grey-200",
                    children: resolvedTheme === "dark" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "md:hidden",
                    children: [
                        "Switch to ",
                        resolvedTheme === "dark" ? "light" : "dark",
                        " mode"
                    ]
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./components/atoms/ThemeToggle/index.ts


;// CONCATENATED MODULE: ./components/molecules/MobileMenu/MobileMenu.tsx




var MobileMenu = function(param) {
    var isOpen = param.isOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("fixed md:hidden z-40 transition-all duration-700 delay-100 ease-in-out bg-gradient-to-b from-grey-200 dark:from-grey-900 to-transparent backdrop-blur-xl w-screen p-4 gap-12", {
            "top-0 h-screen": isOpen,
            "-top-96 h-0 overflow-hidden": !isOpen
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex flex-col justify-center align-center text-center gap-4 h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                    href: "/about",
                    title: "About"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                    href: "/experience",
                    title: "Experience"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                    href: "/recruiters",
                    title: "Recruiters"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex justify-center mt-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeToggle, {})
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./components/molecules/MobileMenu/index.ts


;// CONCATENATED MODULE: ./components/organisms/Header/Header.tsx







var Header = function() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        return function() {
            document.body.style.overflow = "unset";
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "relative z-50 backdrop-blur-md px-4 lg:px-20 py-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "group relative transition whitespace-nowrap hover:transition duration-300 text-2xl font-bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "opacity-100 text-transparent bg-clip-text bg-gradient-to-r from-blue-start to-blue-stop dark:from-purple-start dark:to-purple-stop",
                                    children: "Krutik Parikh"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "hidden md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "flex gap-8 text-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                                        href: "/about",
                                        title: "About"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                                        href: "/experience",
                                        title: "Experience"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* NavigationItem */.D, {
                                        href: "/recruiters",
                                        title: "Recruiters"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "absolute z-50 top-8 right-4 md:hidden",
                            onClick: function() {
                                return setIsOpen(function(prev) {
                                    return !prev;
                                });
                            },
                            "aria-label": "Menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerIcon, {
                                isOpen: isOpen
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeToggle, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
                isOpen: isOpen
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/organisms/Header/index.ts


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./components/atoms/SeoHead/SeoHead.tsx


var SeoHead = function(param1) {
    var title = param1.title, description = param1.description, _author = param1.author, author = _author === void 0 ? "Krutik Parikh" : _author, keywords = param1.keywords, _image = param1.image, image = _image === void 0 ? "" : _image, meta = param1.meta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:url",
                content: "https://krutikparikh.ca/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "/assets/profile.jpg"
            }),
            meta && meta.length > 0 && meta.map(function(param) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: name,
                    content: content
                }, name);
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:image",
                content: image
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-4F0BC8BLV5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', 'G-4F0BC8BLV5', {\n              page_path: window.location.pathname,\n            });\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{"@context":"http://schema.org","@type":"WebSite","name":"krutikparikh.tk","alternateName":"Krutik Parikh","url":"https://krutikparikh.ca/","description":"Software Engineer with a focus on Node.js, React.js and TypeScript. I have more than 5 years experience working in software engineering.","image":"'.concat(image, '"}')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n			"@context": "http://schema.org",\n			"@type": "Person",\n			"image": "",\n			"name": "Krutik Parikh",\n			"alternateName": "parikrut",\n			"url": "https://krutikparikh.ca/",\n			"jobTitle": [\n			  "Senior Software Engineer",\n			  "Frontend Engineer",\n			  "Front-End Developer",\n			  "Web Developer",\n			  "Backend Engineer",\n			  "Back-End Developer",\n			  "Fullstack Engineer",\n			  "Full-Stack Developer"\n			],\n			"hasOccupation": {\n			  "@type": "Occupation",\n			  "name": "Senior Software Engineer",\n			  "occupationLocation": { "@type": "City", "name": "Brampton" },\n			  "estimatedSalary": [\n				{\n				  "@type": "MonetaryAmountDistribution",\n				  "name": "base",\n				  "currency": "CAD",\n				  "duration": "P1H",\n				  "percentile10": "74",\n				  "percentile25": "80",\n				  "median": "90",\n				  "percentile75": "100",\n				  "percentile90": "106"\n				}\n			  ],\n			  "description": "Develops web applications and websites using JavaScript, React and Nodejs.",\n			  "skills": "HTML5, CSS, JavaScript, React, PHP, Sass, Less, Node.js, Express.js, Vue.js, Gatsby, Next.js, JavaScript Frameworks, Git, Github, NPM, SEO, CMS, WordPress, Joomla, Drupal, E-Commerce",\n			  "alternateName": [\n				"Frontend Developer",\n				"Full Stack Developer",\n				"Frontend Engineer"\n			  ],\n			  "responsibilities": [\n				"App Development",\n				"Web Design",\n				"Website Development",\n				"JavaScript Development",\n				"WordPress Development",\n				"CMS Development",\n				"Frontend Development",\n				"Full Stack Development",\n				"Online Marketing",\n				"SEO Services",\n				"Web Developer",\n				"Website Maintenance"\n			  ]\n			},\n			"sameAs": [\n			  "https://www.linkedin.com/in/parikrut/",\n			  "https://github.com/parikrut",\n			  "https://www.youtube.com/channel/UCe0Aoc-4Eo_ywNYsPo5NEKg?view_as=subscriber",\n			  "https://www.instagram.com/ikrutikparikh/"\n			],\n			"brand": [\n			  {\n				"@type": "Brand",\n				"name": "Software Engineer",\n				"alternateName": "Front-End Engineer"\n			  },\n			  { "@type": "Brand", "name": "parikut", "alternateName": "Krutik Parikh" }\n			],\n			"memberOf": [\n				{\n				  "@type": "Organization",\n				  "url": "https://www.hp.com/ca-en/home.html",\n				  "name": "Hp Inc",\n				  "alternateName": "Hewlett-Packard"\n				}\n			  ],\n			"homeLocation": { "@type": "City", "name": "Brampton" },\n			"owns": {\n			  "@type": "Organization",\n			  "url": "https://www.neighbur.com/",\n			  "name": "Neighbur",\n			  "alternateName": "Neighbur",\n			  "sameAs": "https://www.linkedin.com/company/snap-newspaper-group-inc-/"\n			},\n			"alumniOf": {\n			  "@type": "Organization",\n			  "url": "https://www.brandfire.ca/",\n			  "name": "Brandfire"\n			},\n			"nationality": { "@type": "Country", "name": "India" },\n			"birthDate": "1998-12-04",\n			"birthPlace": {\n			  "@type": "Place",\n			  "address": {\n				"@type": "PostalAddress",\n				"addressLocality": "Ahmedabad",\n				"addressCountry": "India"\n			  }\n			}\n		  }\n		  '
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/atoms/SeoHead/index.ts


;// CONCATENATED MODULE: ./layout/Layout/Layout.tsx






var Layout = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? "Krutik Parikh - Software Engineer" : _title, description = param.description, keywords = param.keywords, meta = param.meta;
    var resolvedTheme = (0,index_modern/* useTheme */.F)().resolvedTheme;
    (0,react.useEffect)(function() {
        var favicon = document.querySelector("link[rel~='icon']");
        if (favicon) favicon.href = "/assets/favicon_".concat(resolvedTheme, ".svg");
    }, [
        resolvedTheme
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-between min-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHead, {
                title: title,
                description: description,
                meta: meta,
                keywords: keywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};

;// CONCATENATED MODULE: ./layout/Layout/index.ts



/***/ })

}]);